<div class="chart-container">
  <p *ngIf="title" class="chart-title">{{ title }}</p>
  <canvas class="chart-canvas" #canvas></canvas>
</div>
